import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { button } from "@omni/ui/components/Button/button.style";
import React, { AnchorHTMLAttributes, Ref } from "react";

export type AnchorComponentProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    className?: string;
    test?: string;
    tabIndex?: number;
    dataAttributes?: Record<string, string | undefined>;
    ref?: Ref<HTMLAnchorElement>;
    children?: React.ReactNode;
} & ButtonComponentProps;

export const Anchor = ({
    ref: anchorRef,
    children,
    className,
    size,
    color,
    outline,
    fullWidth,
    loading = false,
    test,
    tabIndex,
    dataAttributes,
    ...anchorHtmlAttributes
}: AnchorComponentProps) => {
    return (
        <a
            {...anchorHtmlAttributes}
            {...dataAttributes}
            data-test={test}
            className={button({
                size,
                color,
                outline,
                fullWidth,
                loading,
                className
            })}
            ref={anchorRef}
            tabIndex={tabIndex}
        >
            {children}
        </a>
    );
};
